import { render, staticRenderFns } from "./ClientProfile.vue?vue&type=template&id=ba352910"
import script from "./ClientProfile.vue?vue&type=script&lang=js"
export * from "./ClientProfile.vue?vue&type=script&lang=js"
import style0 from "./ClientProfile.vue?vue&type=style&index=0&id=ba352910&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports